export default "__VITE_ASSET__D614F5Jl__"